import { jsx as s } from "react/jsx-runtime";
import { CommentEditorAction as r } from "../../../../types.js";
import { CommentRichText as E } from "./style.js";
import { useTranslation as u } from "../../../../../../hooks/useTranslation/index.js";
function y({
  isReply: t,
  submitButtonRef: a,
  quillRef: e,
  quill: n,
  isLoading: m,
  submitted: l,
  dispatch: o,
  uploadHandler: i,
  onSetFocused: p,
  hideImageUploadButton: d = !1
}) {
  const { t: c } = u("common");
  return /* @__PURE__ */ s(
    E,
    {
      quill: n,
      quillRef: e,
      uploadHandler: i,
      hideImageUploadButton: d,
      onUploadError: (C) => {
        o({
          type: r.UPLOAD_ERROR,
          payload: { error: C }
        });
      },
      onClickEditor: () => {
        o({
          type: r.CLICK_ON_EDITOR,
          payload: { isReply: t }
        });
      },
      isLoading: m,
      showToolbarOnFocus: !0,
      "aria-label": c("comment-text-area-aria-label"),
      submitButtonRef: a,
      onSetFocused: p,
      submitted: l
    }
  );
}
export {
  y as CommentInputTextArea,
  E as CommentInputTextAreaContainer
};
